/* eslint-disable no-console */
import React from 'react';
import { useSelector } from 'react-redux';
import { segmentEvent } from '../helpers/sendEvent';
import CheckCircle from '../assets/img/check-circle.png';
import InfoIcon from '../assets/img/kplus-info.svg';

// eslint-disable-next-line no-shadow
function AfterPayment() {
  const store = useSelector(state => ({
    checkoutLookupData: state.personal?.checkoutLookupData,
    resolveRedirectUrl: state.personal?.resolveRedirectUrl,
    afterPaymentPage: state.technical?.offerPageFlow?.afterPaymentPage,
    checkoutUrls: state.loanInfo?.checkout?.urls,
    confirmedKplusAgreement: state.loanInfo?.confirmedKplusAgreement,
    confirmedAonAgreement: state.loanInfo?.confirmedAonAgreement,
    isAonFlow: state.loanInfo?.isAonFlow,
  }));

  const isKplusEnrolled = Boolean(store.confirmedKplusAgreement);
  const isBoostEnrolled = Boolean(store.isAonFlow && store.confirmedAonAgreement);
  const hasMemberships = isKplusEnrolled || isBoostEnrolled;

  const handleCompleteLease = () => {
    window.location.href = store.resolveRedirectUrl;
    segmentEvent('track', 'Complete my lease button clicked on Shopify flow');
  };

  const membershipsCard = hasMemberships && (
    <div className="k-memberships-card">
      <h2 className="k-memberships-card__title">Your memberships</h2>
      <p className="k-memberships-card__subtitle">You&apos;re enrolled in the following memberships:</p>
      {isKplusEnrolled && (
        <div className="k-membership-row">
          <span className="k-membership-row__label">Katapult Protection+</span>
          <span className="k-membership-status-pill">Pending</span>
        </div>
      )}
      {isBoostEnrolled && (
        <div className="k-membership-row">
          <span className="k-membership-row__label">Katapult Boost</span>
          <span className="k-membership-status-pill">Pending</span>
        </div>
      )}
      <div className="k-ownership-timeline__info">
        <img src={InfoIcon} alt="" className="k-ownership-timeline__info-icon" />
        <p>
          Your membership is billed separately from your lease payment, so you may see multiple charges from Katapult.
          You&apos;ll receive a welcome email with additional membership details.
        </p>
      </div>
    </div>
  );

  return (
    <div className="k-content-wrapper k-after-payment">
      {store.afterPaymentPage ? (
        <section className="k-info">
          <div className="k-error-image-wrapper">
            <img width="150" height="150" className="congratulation-icon" src={CheckCircle} alt="" />
          </div>
          <div>
            <h1>Congratulations!</h1>
            <p>Your lease has been confirmed.</p>
            <p>In the next 24 hours, you will receive a welcome email with access to your online account.</p>
          </div>
          {membershipsCard}
        </section>
      ) : (
        <section className="k-info">
          <div className="k-error-image-wrapper">
            <img width="150" height="150" className="congratulation-icon" src={CheckCircle} alt="" />
          </div>
          <div>
            <h1>You&apos;re almost done!</h1>
            <p>Click below to confirm your lease.</p>
            <p>In the next 24 hours, you will receive a welcome email with access to your online account.</p>
          </div>
          <div className="k-submit k-error-button">
            <button type="button" onClick={handleCompleteLease}>
              Complete my lease
            </button>
          </div>
          {membershipsCard}
        </section>
      )}
    </div>
  );
}

export default AfterPayment;
